<template>
  <base-section
    id="hacker"
    class="hh-hacker"
    space="40"
  >
    <v-container>
      <p class="hh-hacker__code mb-0">
        <span class="hh-hacker__brace">{</span> Hacker Hang <span class="hh-hacker__brace">}</span>
        <span class="hh-hacker__arrow">=></span>
        <span class="hh-hacker__string">`AI agents, React Native apps, and social platforms, built by people who ship their own.`</span>
      </p>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'HackerMeaning',
  }
</script>

<style lang="sass">
  .hh-hacker
    border-top: 1px solid var(--hh-line)
    border-bottom: 1px solid var(--hh-line)
    background: rgba(14, 10, 51, .35)

    &__code
      font-family: var(--hh-font-display)
      font-weight: 500
      font-size: clamp(1.15rem, 2vw, 1.5rem)
      line-height: 1.5
      text-align: center
      color: var(--hh-text)

    &__brace
      background: var(--hh-spectrum)
      -webkit-background-clip: text
      background-clip: text
      color: transparent

    &__arrow
      color: var(--hh-muted)
      margin: 0 .5em

    &__string
      color: var(--hh-mint)
      font-family: var(--hh-font-display)
      font-style: italic
      font-weight: 500
</style>
